import { makeStyles } from 'tss-react/mui';

export default makeStyles()(({ palette }) => ({
  link: {
    color: palette.neutral[300],
    textDecoration: 'underline',
  },
}));
